module.exports = __webpack_public_path__ + "media/fonts/FiraSans-Medium-9e604b4c5b46337e1a283d9062b25c63.ttf";